/**
 * Single switch for the analytics WRITE path (ClickHouse inserts).
 *
 * Server code reads SKIP_ANALYTICS. Browser bundles only receive env vars that
 * are NEXT_PUBLIC_-prefixed, so client code reads NEXT_PUBLIC_SKIP_ANALYTICS —
 * set both in .env.dev so local development neither sends events nor stores them.
 *
 * Gating the client senders (not just the API routes) is what keeps the dev
 * server log free of /api/analytics/*\/track request lines.
 *
 * Read-path routes (timelines, stats, dashboards) are unaffected: this only
 * suppresses event collection, never queries.
 */
export function isAnalyticsDisabled(): boolean {
  if (process.env.NEXT_PUBLIC_SKIP_ANALYTICS === 'true') return true;
  if (process.env.SKIP_ANALYTICS === 'true') return true;
  if (process.env.CYPRESS === 'true') return true;
  return false;
}
